import React, { useState, useEffect, useRef  } from 'react';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';

import Row from 'react-bootstrap/Row'

import { Trash } from "react-bootstrap-icons";
import { Plus } from "react-bootstrap-icons";
import { PencilSquare } from "react-bootstrap-icons";
import { Check } from "react-bootstrap-icons";

const Edit = () => {
    
    const formRef = useRef(null);
    const [date, setdatum] = useState("");
    const [formvalues, setValues] = useState({});
    const [updatevalues, setupdatevalues] = useState({});
    const [validated, setValidated] = useState(false);
    const [data, setdata] = useState([]);
    const [editindex, seteditindex] = useState(null);

    const onFormChange = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      setValues({ ...formvalues, [name]: value });
    };

    const onFormUpdate = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setupdatevalues({ ...updatevalues, [name]: value });
      };

    const onDateChange = (e) => {
        console.log(e.target.value)
        const date = e.target.value;
        setdatum({date});
      };
  
    const handleSubmit = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
          event.preventDefault();
          event.stopPropagation();
        }
    
      setValidated(true);
      event.preventDefault();
      event.persist();

      setValues({})
      let newdata= [];
     
     if (Object.keys(formvalues).length >= 6){
        if (data.length === 0){
            newdata.push(formvalues)
            setdata(newdata)
            formRef.current.reset();
            setValidated(false);
        } else {
            newdata = data
            newdata.push(formvalues)
            setdata(newdata)
            formRef.current.reset();
            setValidated(false);
        }
    }
  
    };



    const handleRemoveWithIndex = (index) => { 
       let newdata = [...data] 
       newdata.splice(index, 1)
       setdata(newdata)
       formRef.current.reset();
    };

    const handleEditRow = (index) => {
        seteditindex(index)
        setupdatevalues(data.at(index))
    }

    const handleUpdate = (e) => {
        e.preventDefault();
        e.stopPropagation();

        let updatedata = [...data]
        updatedata[editindex] = updatevalues

        setdata(updatedata)
        seteditindex(null)
    }

    const clearData = (e) => {
        setdata([])
        setdatum("")
        setValues({})
        setupdatevalues({})
        createJson()
      }

    const createJson = () => {
      let jsonfields = JSON.stringify(data);
     
      let json;
            json = '{';
            json += '"date": "' + date.date + '",';
            json += '"type": "new",';
            json += '"data":';
            json += jsonfields;
            json += '}'; 

     console.log(json)
     updateScreenData(json)
    }



    async function updateScreenData(json) {
      const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: json
    };
    fetch('/screendata', requestOptions)
        ///.then(response => response.json())
        .then(res =>  console.log("DATA:_ ", res) );
    }

    async function fetchSreenData() {
      const response = await fetch('screendata');
      const data = await response.json();
      setdata(data.data)
      setdatum(data.date)
    }


    useEffect(() => {
      fetchSreenData()
    }, []);
    

  

   
return (
<Container fluid className="mt-3">   
<Row className="mb-3">
        <Form.Group as={Col} md="2" controlId="validationCustom01">
          <Form.Control
            required
            type="text"
            placeholder="DD-MM-YYYY"
            name="date"
            onChange={onDateChange}
          />
        </Form.Group>
    </Row>


<Form ref={formRef}  noValidate validated={validated} onSubmit={handleSubmit}>
      
      <Row className="mb-3">
        <Form.Group as={Col} md="2" controlId="validationCustom03">
          <Form.Control 
            type="text" 
            placeholder="Frächter" 
            required 
            name="freighter"
            onChange={onFormChange}
            />
        </Form.Group>
        <Form.Group as={Col} md="2" controlId="validationCustom04">
          <Form.Control 
             type="text" 
             placeholder="Referenz" 
             required 
             name="reference"
             onChange={onFormChange}
             /> 
        </Form.Group>
        <Form.Group as={Col} md="1" controlId="validationCustom05">
          <Form.Control 
             type="text" 
             placeholder="Kommission" 
             required 
             name="commission" 
             onChange={onFormChange}
             />
        </Form.Group>
        <Form.Group as={Col} md="2" controlId="validationCustom06">
          <Form.Control 
            type="text" 
            placeholder="Lagerort" 
            required 
            name="stockplace"
            onChange={onFormChange}
            />
        </Form.Group>
        <Form.Group as={Col} md="1" controlId="validationCustom07">
          <Form.Control 
             type="text" 
             placeholder="Pal. Anzahl" 
             required 
             name="quantity"
             onChange={onFormChange}
             />
        </Form.Group>
        <Form.Group as={Col} md="2" controlId="validationCustom08">
          <Form.Control 
             type="text" 
             placeholder="Kennzeichen" 
             required 
             name="licenseplate"
             onChange={onFormChange}
             />
        </Form.Group>
        <Form.Group as={Col} md="1" controlId="validationCustom08">
          <Form.Control 
            type="text" 
            placeholder="Ladereihenfolge" 
            required 
            name="loadingorder"
            onChange={onFormChange}
            />
        </Form.Group>
        <Form.Group as={Col} md="1" controlId="validationCustom08">
                <Button type="submit"><Plus /></Button>
        </Form.Group>
      </Row>
      
      
    </Form>
    <hr />
{data.length !== 0 &&
<>

   <h2>Datum: {date.date}</h2>
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>Frächter</th>
          <th>Referenz</th>
          <th>Kommission</th>
          <th>Lagerort</th>
          <th>Pal. Anzahl</th>
          <th>Kennzeichen</th>
          <th>Ladereihenfolge</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
      
      {(data || []).map(function(item, index)  {

        if (editindex === index) {
            return (
<tr key={index}> 
<td colSpan="8">   
   <Form ref={formRef}  noValidate validated={validated} onSubmit={handleUpdate}>
      
      <Row className="mb-3">
        <Form.Group as={Col} md="2" controlId="validationCustom03">
          <Form.Control 
            type="text" 
            placeholder="Frächter" 
            required 
            name="freighter"
            value={updatevalues.freighter}
            onChange={onFormUpdate}
            />
        </Form.Group>
        <Form.Group as={Col} md="2" controlId="validationCustom04">
          <Form.Control 
             type="text" 
             placeholder="Referenz" 
             required 
             name="reference"
             value={updatevalues.reference}
             onChange={onFormUpdate}
             /> 
        </Form.Group>
        <Form.Group as={Col} md="1" controlId="validationCustom05">
          <Form.Control 
             type="text" 
             placeholder="Kommission" 
             required 
             name="commission" 
             value={updatevalues.commission}
             onChange={onFormUpdate}
             />
        </Form.Group>
        <Form.Group as={Col} md="2" controlId="validationCustom06">
          <Form.Control 
            type="text" 
            placeholder="Lagerort" 
            required 
            name="stockplace"
            value={updatevalues.stockplace}
            onChange={onFormUpdate}
            />
        </Form.Group>
        <Form.Group as={Col} md="1" controlId="validationCustom07">
          <Form.Control 
             type="text" 
             placeholder="Pal. Anzahl" 
             required 
             name="quantity"
             value={updatevalues.quantity}
             onChange={onFormUpdate}
             />
        </Form.Group>
        <Form.Group as={Col} md="2" controlId="validationCustom08">
          <Form.Control 
             type="text" 
             placeholder="Kennzeichen" 
             required 
             name="licenseplate"
             value={updatevalues.licenseplate}
             onChange={onFormUpdate}
             />
        </Form.Group>
        <Form.Group as={Col} md="1" controlId="validationCustom08">
          <Form.Control 
            type="text" 
            placeholder="Ladereihenfolge" 
            required 
            name="loadingorder"
            value={updatevalues.loadingorder}
            onChange={onFormUpdate}
            />
        </Form.Group>
        <Form.Group as={Col} md="1" controlId="validationCustom08">
                <Button type="submit"><Check /></Button>
        </Form.Group>
      </Row>
      
      
    </Form>         
    </td>      
    </tr> 
              )
            
        }
        
        return (
            <tr key={index}>
              <td>{item.freighter}</td>
              <td>{item.reference}</td>
              <td>{item.commission}</td>
              <td>{item.stockPlace}</td>
              <td>{item.quantity}</td>
              <td>{item.licenseplate}</td>
              <td>{item.loadingorder}</td>
              <td className="text-center">
                  <Trash size={20} onClick={() => handleRemoveWithIndex(index)} /> 
                  <PencilSquare size={20} onClick={() => handleEditRow(index)} />
              </td>
          </tr> 
          )
        
      }, editindex )}

       
      </tbody>
 </Table>
 {data.length !== 0 &&
 <>
<hr />
 <Row>
        <Col><div className="d-grid gap-2"><Button variant="success" size="lg" onClick={() => createJson()}><Check size={26} /> Daten veröffentlichen</Button></div></Col>
        <Col><div className="d-grid gap-2"><Button variant="danger" size="lg" onClick={() => clearData()}><Trash  size={26} /> Daten löschen</Button></div></Col>
      </Row>
      </>
}
 </>
 }  
</Container>      
    );
  }


export default Edit;
